import { defineMessages } from 'react-intl';

export default defineMessages({
    searchButton: {
        defaultMessage: 'Submit search query',
        description: 'Accessible text for the Submit button that is used to show the search.',
        id: 'cv.search.button',
    },
});
